export const formatCurrency = (amount: number): string =>
  new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(amount);

export const getTotalItemPrice = (pricePerUnit: number, quantity = 1): string =>
  formatCurrency(pricePerUnit * quantity);
